import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  button: {
    borderRadius: 6,
    boxShadow: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    height: '25px',
    '& .MuiButton-label':{
      display: 'flex',
      alignItems: 'center',
      gap: 8
    }
  },
  primary: {
    backgroundColor: theme.palette.blue_300.main,
    color: theme.palette.white_100.main,
    '&:hover': {
      backgroundColor: theme.palette.blue_400.main,
      boxShadow: 'none'
    }
  },
  success: {
    backgroundColor: theme.palette.green_200.main,
    color: theme.palette.white_100.main,
    '&:hover': {
      backgroundColor: theme.palette.green_500.main,
      color: theme.palette.white_100.main,
      boxShadow: 'none'
    }
  }
}))
